// UpdatePassword.jsx 

import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "../../css/Auth/Password.css";
import AuthCard from "../../components/ui/Cards/AuthCard";
import Input from "../../components/ui/Input/Input";
import Botton from "../../components/ui/Button/Button";
import { FaArrowRightToBracket } from "react-icons/fa6";
import { toast } from "react-toastify";
import logo from "../../assets/images/logo1.png";
import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
import logo1 from "../../assets/images/logo3.png";
import logo2 from "../../assets/images/Frame 47.png";
import logo3 from "../../assets/images/Frame 35.png";
import logo4 from "../../assets/images/logo7.png";
import logo5 from "../../assets/images/logo4.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export const UpdatePassword = () => {
  const { id, token } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const phoneNumber = location.state?.phoneNumber;
  console.log(phoneNumber, "phoneumber");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isCheck, setIsCheck] = useState(null);
  
  // New state for password length validation
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  // Password validation function
  const validatePassword = (pass) => {
    if (!pass) return "";
    if (pass.length < 6) return "Password must be at least 6 characters";
    if (pass.length > 10) return "Password must not exceed 10 characters";
    return "";
  };

  useEffect(() => {
    // Validate password length
    const passError = validatePassword(password);
    setPasswordError(passError);
    
    // Check password match (only if both fields have values)
    if (!password && !confirmPassword) {
      setIsCheck(null);
      setConfirmPasswordError("");
    } else if (password && confirmPassword) {
      if (password === confirmPassword) {
        if (!passError) {
          setIsCheck(true);
          setConfirmPasswordError("");
        } else {
          setIsCheck(false);
          setConfirmPasswordError(passError);
        }
      } else {
        setIsCheck(false);
        setConfirmPasswordError("Passwords do not match");
      }
    } else if (password && !confirmPassword) {
      setIsCheck(false);
      setConfirmPasswordError("");
    } else if (!password && confirmPassword) {
      setIsCheck(false);
      setConfirmPasswordError("");
    }
  }, [password, confirmPassword]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation checks
    if (!password || !confirmPassword) {
      toast.error("All fields required");
      return;
    }
    
    // Check password length
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    
    if (password.length > 10) {
      toast.error("Password must not exceed 10 characters");
      return;
    }
    
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    
    try {
      setLoading(true);
      const res = await api.post("/auth/forgot-password/reset", {
        phone: phoneNumber,
        newPassword: password,
        confirmPassword,
      });
      toast.success("Password reset successfully. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error("Unable to reset password. Try again.");
    } finally {
      setLoading(false);
    }
  };

  // Handle password change with max length limit
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setPassword(value);
    }
  };

  // Handle confirm password change with max length limit
  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setConfirmPassword(value);
    }
  };

  return (
    <AuthCard
      title="Welcome To Bharat Jagriti ™"
      description="EXPLORE THE TRUTH TO THE WORLD"
      pageTitle="Reset Password"
      bottomImg={LogoBottom}
      bottomName="Powered by Sripuram"
      allImg={[logo3, logo2, logo4, logo5, logo1]}
      headLogo={logo}
    >
      <div className="update_password_section">
        {/* Password input field */}
        <div className="reset-pass-input_box" style={{ position: "relative" }}>
          <label>Enter New Password</label>
          
          {/* Password length hint */}
          <small style={{ 
            display: 'block', 
            marginBottom: '5px', 
            fontSize: '12px', 
            color: '#666' 
          }}>
            Password must be 6-10 characters
          </small>

          <Input
            placeholder="Enter New Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onchangeInput={handlePasswordChange}
            length={50}
            disabled={loading}
            style={{ paddingRight: "40px" }}
          />

          <span
            onClick={() => setShowPassword((prev) => !prev)}
            style={{
              position: "absolute",
              right: "12px",
              top: "55px",
              cursor: "pointer",
              color: "#666",
              fontSize: "18px",
            }}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
          
          {/* Password error message */}
          {passwordError && (
            <small style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block" }}>
              {passwordError}
            </small>
          )}
          
          {/* Password length indicator */}
          {password && (
            <small style={{ 
              fontSize: "12px", 
              color: password.length >= 6 && password.length <= 10 ? "green" : "orange",
              marginTop: "3px",
              display: "block"
            }}>
              {/* {password.length}/10 characters {password.length < 6 && "(min 6 needed)"} */}
            </small>
          )}
        </div>

        {/* Confirm Password input field */}
        <div className="reset-pass-input_box" style={{ position: "relative" }}>
          <label>Confirm Password</label>

          <Input
            placeholder="Confirm New Password"
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onchangeInput={handleConfirmPasswordChange}
            length={50}
            disabled={loading}
            style={{ paddingRight: "40px" }}
          />

          <span
            onClick={() => setShowConfirmPassword((prev) => !prev)}
            className={`${isCheck === true ? "isMatch" : ""}`}
            style={{
              position: "absolute",
              right: "10px",
              top: "55px",
              cursor: "pointer",
              color: "#666",
              fontSize: "18px",
            }}
          >
            {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
          
          {/* Confirm password match indicator */}
          {confirmPassword && (
            <small style={{ 
              fontSize: "12px", 
              color: isCheck === true ? "green" : isCheck === false ? "red" : "#666",
              marginTop: "5px",
              display: "block"
            }}>
              {isCheck === true ? "✓ Passwords match" : isCheck === false ? "✗ Passwords do not match" : ""}
            </small>
          )}
          
          {/* Confirm password error message */}
          {confirmPasswordError && !isCheck && confirmPassword && (
            <small style={{ color: "red", fontSize: "12px", marginTop: "3px", display: "block" }}>
              {confirmPasswordError}
            </small>
          )}
        </div>
      </div>

      {/* Submit button - disabled if validation fails */}
      <Botton
        onClick={handleSubmit}
        className="NextBtn"
        style={{
          width: "60%",
          color: "white",
          padding: "8px 20px",
          borderRadius: "20px",
          backgroundColor: "var(--color1)",
          margin: "30px auto",
          display: "flex",
          justifyContent: "center",
          fontSize: "15px",
          alignItems: "center",
          opacity: (passwordError || !isCheck || !password || !confirmPassword) ? 0.6 : 1,
          cursor: (passwordError || !isCheck || !password || !confirmPassword) ? "not-allowed" : "pointer",
        }}
        disabled={!!passwordError || !isCheck || !password || !confirmPassword || loading}
        children={loading ? "Updating..." : "Reset Password"}
        icon={FaArrowRightToBracket}
      />
    </AuthCard>
  );
};

export default UpdatePassword;